<style>
	.tips-auto-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: -50px;
		/*z-index: 50;*/
		/*大于loading层 2017/5/16 shang*/
		z-index: 150;
		background-color: rgba(0,0,0,0);
	}
	.tips-auto-mask .tips-auto-wrapper{
		padding: 5px;
		position: absolute;
		top:40%;
		left: 50%;
		width: 150px;
		height: 150px;
		margin-left: -75px;
		margin-top: -75px;
		border-radius: 5px;
		background-color: rgba(0,0,0,.7);
		box-shadow: 0px 5px 10px rgba(0,0,0,.1);
	}
	.tips-auto-mask .tips-auto-wrapper .tips-auto-icon{
		width: 32px;
		height: 32px;
		margin: 0 auto;
		margin-top: 15px;
		background-repeat: no-repeat;
	}
	.tips-auto-mask .tips-auto-wrapper .tips-auto-font{
		margin-top: 5px;
		text-align: center;
		box-sizing: border-box;
		padding: 2px;
		vertical-align: middle;
		color: #fff;
		font-size: 14px;
		line-height: 20px;
	}
	.tips-auto-show{
		opacity: 1;
		animation: tipsAutoUp .3s;
		-webkit-animation: tipsAutoUp .3s;
	}
	@keyframes tipsAutoUp
	{
		from {opacity: 0;}
		to {opacity: 1;}
	}
	@-webkit-keyframes tipsAutoUp
	{
		from {opacity: 0;}
		to {opacity: 1;}
	}
	.tips-auto-hide{
		opacity: 0;
		animation: tipsAutoDown .3s;
		-webkit-animation: tipsAutoDown .3s;
	}
	@keyframes tipsAutoDown
	{
		from {opacity: 1;}
		to {opacity: 0;}
	}
	@-webkit-keyframes tipsAutoDown
	{
		from {opacity: 1;}
		to {opacity: 0;}
	}
</style>

<template>
	<div class="tips-auto-mask">
		<div class="tips-auto-wrapper" :class="{'tips-auto-show': opacityShow, 'tips-auto-hide': !opacityShow}">
			<div class="tips-auto-icon" :class="tipsAutoIco"></div>
			<div class="tips-auto-font">{{tipsFont}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			tipsFont: String,
			tipsAutoIco: String
		},
		data () {
			return {
				opacityShow: true
			}
		},
		methods: {
			open () {
				this.opacityShow = true
			}
		}
	}
</script>



// WEBPACK FOOTER //
// TipsAutoHasMiddleStyle.vue?2ff13d40